export const SERVICE_DETAILS = {
  "skin-prick": {
    title: "Skin Prick Allergy Test",
    paragraphs: [
      "The Skin Prick Test is the gold-standard first-line investigation for identifying exactly what triggers your allergies. Tiny drops of purified allergen extracts are placed on the forearm and the skin is gently pricked — the test is quick, nearly painless, and results appear within 15–20 minutes.",
      "A small raised bump (like a mosquito bite) at a spot confirms sensitivity to that allergen. Knowing your exact triggers allows Dr. Amol Shembatwad to design a precise avoidance and treatment plan instead of guessing.",
    ],
    bulletsTitle: "Allergens it can detect",
    bullets: [
      "House dust mites and dust",
      "Pollens from trees, grasses and weeds",
      "Mold and fungal spores",
      "Pet dander (cats, dogs)",
      "Common food allergens",
      "Insect venom and other environmental triggers",
    ],
    footnote: "Why it's needed: unexplained sneezing, wheezing, skin rashes or breathing trouble often have an allergic root cause. This test finds it in a single OPD visit.",
    images: [
      { src: "/assets/skin-prick-test.webp", label: "Skin Prick Allergy Test — performed at our clinic", scope: false },
    ],
    video: {
      label: "Skin Prick Allergy Test",
      desc: "Watch a real skin prick allergy test being performed at our clinic.",
      videoFile: "/assets/skin-prick-test.mp4",
      videoFileWebm: "/assets/skin-prick-test.webm",
      poster: "/assets/skin-prick-test-poster.webp",
    },
  },
  bronchoscopy: {
    title: "Bronchoscopy",
    paragraphs: [
      "Bronchoscopy lets the doctor look directly inside your airways using a thin, flexible camera passed gently through the nose or mouth. It is the most accurate way to diagnose persistent cough, infections, bleeding, blockages and suspected lung disease.",
      "At Shri Sai Chest and Allergy Hospital, bronchoscopy is performed by Dr. Amol Shembatwad himself, with trained staff, live monitoring and strict safety protocols. The procedure typically takes 15–30 minutes and most patients go home the same day.",
    ],
    bulletsTitle: "When is it advised",
    bullets: [
      "Chronic cough that doesn't respond to treatment",
      "Blood in sputum (haemoptysis)",
      "Suspected infection, TB or tumor in the airways",
      "Foreign body inhalation — especially in children",
      "Collecting samples (lavage/biopsy) for exact diagnosis",
    ],
    video: {
      label: "Live Bronchoscopy: Airway Findings in Pneumonia",
      desc: "Real endoscopic footage showing mucus-filled airways during pneumonia, captured by Dr. Amol Shembatwad",
      videoFile: "/assets/live-bronchoscopy-pneumonia.mp4",
      videoFileWebm: "/assets/live-bronchoscopy-pneumonia.webm",
      poster: "/assets/live-bronchoscopy-pneumonia-poster.webp",
    },
  },
  thoracoscopy: {
    title: "Thoracoscopy",
    paragraphs: [
      "Thoracoscopy is a minimally invasive keyhole examination of the pleural space — the area between the lungs and the chest wall. Through a tiny incision, a scope gives a direct, magnified view that scans alone cannot provide.",
      "It is invaluable when fluid keeps collecting around the lung, when the pleura appears thickened, or when a precise biopsy is needed. Dr. Amol Shembatwad is trained in interventional pulmonology procedures including thoracoscopy.",
    ],
    bulletsTitle: "What it helps diagnose",
    bullets: [
      "Recurrent or unexplained pleural effusion (fluid around lungs)",
      "Pleural thickening or masses",
      "Tuberculosis of the pleura",
      "Staging and biopsy of pleural disease",
    ],
    images: [
      { src: "/images/image-1.webp", label: "Live Thoracoscopy View — Parietal", scope: true },
      { src: "/images/image-8.webp", label: "Live Thoracoscopy View — Pleura", scope: true },
    ],
    video: {
      label: "Thoracoscopy",
      desc: "Live thoracoscopy procedure by Dr. Amol Shembatwad",
      videoFile: "/assets/hospital-tour.mp4",
      videoFileWebm: "/assets/hospital-tour.webm",
      poster: "/assets/hospital-tour-poster.webp",
    },
  },
  "pft-fot": {
    title: "PFT & FOT Diagnostics",
    paragraphs: [
      "Pulmonary Function Testing (PFT) measures how much air your lungs can hold and how quickly you can move air in and out — the single most important test for asthma, COPD, ILD and unexplained breathlessness.",
      "Forced Oscillometry Testing (FOT) is an even gentler technique: the patient simply breathes normally while the device measures airway resistance. It is ideal for children, elderly patients, and anyone who cannot perform forceful breathing maneuvers.",
      "Both tests are performed in our dedicated PFT and FOT room, ensuring accurate, comfortable and quick testing — reports are discussed with you the same visit.",
    ],
    bulletsTitle: "What these tests detect",
    bullets: [
      "Asthma and its severity grading",
      "COPD and chronic airflow obstruction",
      "Restrictive lung diseases (ILD, fibrosis)",
      "Response to inhaler treatment over time",
      "Fitness for surgery and procedures",
    ],
    images: [
      { src: "/assets/pft-fot-room.webp", label: "Dedicated PFT & FOT Room", scope: false },
      { src: "/assets/pft-in-progress.webp", label: "PFT (Pulmonary Function Test) — in progress", scope: false },
    ],
  },
};
